import type { AcknowledgementPayloadDTO } from "@/core/types";
import { patientRequestsTyped } from "@/api/(requests)/patientTyped";

export async function appendAcknowledgement(data: AcknowledgementPayloadDTO) {
  return patientRequestsTyped.append_acknowledgement({ context: { showLoader: false }, data });
}
